var chunkToChildrenMap = {"8074":["5139","4352","9925","3831"],"1591":["5139","4352","9925","3831"],"8783":["5139","4352","9925","3831"],"9626":["5139","4352","9925","3831"],"2871":["5139","4352","9925","3831"],"4118":["5139","4352","9925","3831"],"9102":["5139","4352","9925","3831"]};
__webpack_require__.f.prefetch = (chunkId, promises) => {
  Promise.all(promises).then(() => {
    var chunks = chunkToChildrenMap[chunkId];
    Array.isArray(chunks) && chunks.map(__webpack_require__.E);
  });
};